import axios from "@/utils/axios"


export const productList = async (doc:any) => {
    try {
        let result = await axios.post(`${process.env.NEXT_PUBLIC_PRODUCT_SERVICE}/v1/product/list`,doc)
        if (result?.data?.status) {
            return { status: true, data: result?.data, message: result?.data?.message }
        } else {
            return { status: true, error: result?.data?.error || result?.data?.message }
        }
    } catch (error: any) {
        return { status: true, error: error.message }
    }
}